import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constants/Endpoints/EndPoints";
import { FetchRequestHandler } from "../../utils/commonUtilities";

export const fetchProviderStatus = createAsyncThunk(
  "fetchProviderStatus",
  async (providerId) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/providers/${providerId}/status`
    );
    return result;
  }
);

export const updateProviderStatus = createAsyncThunk(
  "updateProviderStatus",
  async ({ providerId, data }) => {
    const result = await FetchRequestHandler(
      "put",
      `${baseUrl}api/providers/${providerId}/status`,
      data
    );
    return result;
  }
);

export const providerDuplicateCheck = createAsyncThunk(
  "providerDuplicateCheck",
  async (query) => {
    const result = await FetchRequestHandler(
      "get",
      // `${baseUrl}api/providers/${providerId}/status`,
      `${baseUrl}api/providers?field=all&page-number=1&page-size=1&query=${query}&view=search`
    );
    return result;
  }
);
